import {Link} from 'react-router-dom';
import {useCallback, useRef, useState} from 'react';

import Container from 'components/container/Container';
import Input from 'components/input/Input';
import Button from 'components/button/Button';
import {getServices} from 'services/index';
import {UserValidationErrors} from 'services/User';

const LoginPage = () => {
  const input = useRef({email: '', password: ''});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({} as UserValidationErrors);

  const login = useCallback(async () => {
    setLoading(true);
    setErrors({} as UserValidationErrors);
    const {email, password} = input.current;
    const {authService} = getServices();
    try {
      await authService.login({email, password});
    } catch (exp) {
      setLoading(false);
      const msg = (exp as Error)?.message ?? 'An error occurred';
      setErrors((existing) => ({
        ...existing,
        [msg.toLowerCase().includes('email') ? 'email' : 'password']: {
          description: msg,
          status: 'error',
        },
      }));
    }
  }, []);

  return (
    <Container>
      <form
        className="w-full max-w-md"
        onSubmit={(event) => {
          event.preventDefault();
          login();
        }}
      >
        <h1 className="text-3xl font-bold mb-4 text-brand-forest">Log In</h1>
        <Input
          onInput={(e) => {
            input.current.email = e.currentTarget.value;
          }}
          placeholder="Email"
          type="email"
          message={errors.email}
          required
        />
        <Input
          onInput={(e) => {
            input.current.password = e.currentTarget.value;
          }}
          placeholder="Password"
          type="password"
          required
          message={errors.password}
        />
        <Button
          disabled={loading}
          className={loading ? 'bg-grey5' : ''}
          title="Log In"
          onClick={login}
        />
        <Link to="/register">
          <p className="text-center text-label uppercase tracking-widest font-medium">
            don't have an account{' '}
            <span className="text-brand-forest">sign up</span>
          </p>
        </Link>
      </form>
    </Container>
  );
};

export default LoginPage;
